<template>
  <div class="balances">
    <div v-if="!isSupplier" class="actions-wrapper">
      <div class="actions-left">
        <rcc-button @click="isShowRegionsSelectModal = true">
          Фильтр по регионам
        </rcc-button>

        <rcc-button
          color="primary"
          :is-loading="isBalanceRefreshLoading"
          @click="handleBalanceRefresh"
        >
          Обновить балансы
        </rcc-button>

        <span v-if="balanceRefreshMessage" class="refresh-status">
          {{ balanceRefreshMessage }}
        </span>
      </div>

      <rcc-button
        color="success"
        :is-loading="isExcelUploadLoading"
        @click="handleExcelUploadClick"
      >
        Выгрузить в Excel
      </rcc-button>
    </div>

    <component ref="balancesTable" :is="component" />

    <rcc-regions-select-modal
      v-model="isShowRegionsSelectModal"
      :save-callback="handleRegionsSelect"
      :selected-regions="selectedRegions"
      max-width="700px"
    />
  </div>
</template>

<script>
import getXls from '@/utils/get-xls'

import RccButton from 'Components/controls/rcc-button'
import RccRegionsSelectModal from './components/regions-select-modal'

const RccCommonBalances = () => import('./components/common.vue')
const RccCommonRccBalancesForSupplierRoleBalances = () => import('./components/supplier.vue')

export default {
  components: {
    RccButton,
    RccRegionsSelectModal
  },

  data() {
    return {
      isExcelUploadLoading: false,
      isBalanceRefreshLoading: false,
      balanceRefreshMessage: '',
      isShowRegionsSelectModal: false,
      selectedRegions: [],
      balanceRefreshTimer: null
    }
  },

  computed: {
    isSupplier() {
      return this.$store.user.role === this.$constants.users.supplier
    },

    component() {
      return this.isSupplier ? RccCommonRccBalancesForSupplierRoleBalances : RccCommonBalances
    }
  },

  methods: {
    handleBalanceRefresh() {
      if (this.isBalanceRefreshLoading) return

      this.isBalanceRefreshLoading = true
      this.balanceRefreshMessage = 'Запускаем обновление...'
      this.$apiMethods.suppliers.refreshBalances()
        .then(() => this.pollBalanceRefresh())
        .catch(() => {
          this.isBalanceRefreshLoading = false
          this.balanceRefreshMessage = 'Не удалось запустить обновление'
        })
    },

    pollBalanceRefresh() {
      this.$apiMethods.suppliers.balanceRefreshStatus()
        .then(status => {
          if (status.status === 'running') {
            this.balanceRefreshMessage = 'Обновляем балансы...'
            this.balanceRefreshTimer = setTimeout(() => this.pollBalanceRefresh(), 2000)
            return
          }

          this.isBalanceRefreshLoading = false
          if (status.status === 'completed') {
            this.balanceRefreshMessage = `Готово: обновлено ${status.updated}, пропущено ${status.skipped}`
            this.$refs.balancesTable.loadData()
          } else {
            this.balanceRefreshMessage = 'Обновление завершилось с ошибкой'
          }
        })
        .catch(() => {
          this.isBalanceRefreshLoading = false
          this.balanceRefreshMessage = 'Не удалось получить статус обновления'
        })
    },

    handleExcelUploadClick() {
      this.isExcelUploadLoading = true

      this.$apiMethods.suppliers.getExcel(this.$refs.balancesTable?.getFiltersQuery() || {})
        .then(response => {
          getXls.bind(this)(response)
        })
        .finally(() => { this.isExcelUploadLoading = false })
    },

    handleRegionsSelect(regions) {
      this.selectedRegions = regions
      this.$refs.balancesTable.loadData(null, { region_ids: regions })
    }
  },

  beforeDestroy() {
    if (this.balanceRefreshTimer) {
      clearTimeout(this.balanceRefreshTimer)
    }
  }
}
</script>

<style lang="scss" scoped>
.balances {
  display: flex;
  height: 100%;
  flex-direction: column;
  padding: $base-page-padding;

  .actions-wrapper {
    display: flex;
    justify-content: space-between;
    margin-bottom: 15px;
  }

  .actions-left {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .refresh-status {
    color: $base-text-color;
    font-size: 13px;
  }
}
</style>
